<template>
  <div class="liquidaciones-sueldos-pagos-data">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card :header="titulo">
          <b-table 
              small
              class="datos-objeto"  
              :busy="tableBusy" 
              :items="pagoDatos" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Personal">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes personal"
              :items="pagoPersonal" 
              :fields="personalFields">
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Efectivo" v-if="pagoDocumentos.length != 0">
          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy" 
              class="registro-ordenes"
              :items="pagoDocumentos" 
              :fields="documentosFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <!-- <template v-slot:cell(documentoNumero)="data">
              {{ data.item.documentoNumero }}
            </template> -->
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Transferencias" v-if="pagoTransferencias.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes transferencias"
              :items="pagoTransferencias" 
              :fields="transferenciasFields">
            <template v-slot:cell(fechaCreditoDebito)="data">
              {{ data.item.fechaCreditoDebito | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                    @click.stop="actualizarCuenta(data.item)">
                  <i class="fa fa-edit"></i>Actualizar Cuenta</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-card>

        <b-card header="Cheques Propios" v-if="pagoChequesPropios.length != 0">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="pagoChequesPropios" 
              :fields="chequesPropiosFields">
            <template v-slot:cell(fechaEmision)="data">
              {{ data.item.fechaEmision | fecha }}
            </template>
            <template v-slot:cell(fechaPago)="data">
              {{ data.item.fechaPago | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <b-modal ref="movimientoModal"
        title="Actualización del Movimiento"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-actualizacion-cuenta
        :bancoMovimientoId="bancoMovimientoId"
        :bancoCuenta="bancoCuenta"
        @closeActualizacion="closeActualizacion">
      </app-actualizacion-cuenta>  
    </b-modal>
  </div>
</template>

<script>
import ActualizacionCuenta from '../bancosmovimientos/ActualizacionCuenta.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'liquidacionSueldosPagoDatos/getField',
  mutationType: 'liquidacionSueldosPagoDatos/updateField',
});

export default {
  name: 'LiquidacionSueldosPagoData',
  components: {
    appActualizacionCuenta: ActualizacionCuenta,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      liquidacionSueldosId: 0,
      liquidacionSueldosPagoId: 0,

      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      personalFields: [
        { 
          key: 'personal',
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      documentosFields: [
        { 
          key: 'documentoTipo',
          label: 'Moneda'
        },
        // { 
        //   key: 'documentoNumero',
        //   label: 'Nro.Documento'
        // },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      transferenciasFields: [
        {
          key: 'fechaCreditoDebito',
          label: 'Fecha Debito'
        },
        {
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      chequesPropiosFields: [
        {
          key: 'fechaEmision',
          label: 'Fecha Emisión'
        },
        { key: 'fechaPago' },
        {
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        { 
          key: 'numero',
          label: 'Número',
          class: 'text-right'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
      ],

      tableBusy: false,
      bancoMovimientoId: 0,
      bancoCuenta: ''
    }
  },
  computed: {
    ...mapFields([
      'pagoDatos',
      'pagoPersonal',
      'pagoDocumentos',
      'pagoTransferencias',
      'pagoChequesPropios'
    ]),
    titulo() {
      return 'Información del Pago de Honorarios';
    },
  },
  created() {
    if (this.$route.params) {
      this.liquidacionSueldosId = this.$route.params.liquidacionSueldosId;
      this.liquidacionSueldosPagoId = this.$route.params.id;
    }

    this.getDatos();
  },  
  methods: {
    getDatos() {
      let params = {
        liquidacionSueldosId: this.liquidacionSueldosId,
        liquidacionSueldosPagoId: this.liquidacionSueldosPagoId
      }

      this.tableBusy = true;
      this.$store.dispatch('liquidacionSueldosPagoDatos/getDatos', params)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    goBack() {
      this.$router.go(-1);
    },
    actualizarCuenta(item) {
      this.bancoMovimientoId = item.id;
      this.bancoCuenta = item.bancoCuenta.trim();
      this.$refs.movimientoModal.show();
    },  
    closeActualizacion(actualizado) {
      if ((/true/i).test(actualizado)) {
        this.getDatos();
      }
      this.$refs.movimientoModal.hide();
    }
  }
}
</script>

<style>
  .liquidaciones-sueldos-pagos-data .registro-ordenes.transferencias table td {
    vertical-align: middle;
    /* border: none; */
  }
  .liquidaciones-sueldos-pagos-data .registro-ordenes.transferencias table td[aria-colindex="1"] {
    width: 20%;
  }
  .liquidaciones-sueldos-pagos-data .registro-ordenes.transferencias table td[aria-colindex="2"] {
    width: calc(50% - 30px);
  }
  .liquidaciones-sueldos-pagos-data .registro-ordenes.transferencias table td[aria-colindex="3"] {
    width: 30%;
  }
  .liquidaciones-sueldos-pagos-data .registro-ordenes.transferencias table td[aria-colindex="4"] {
    width: 30px;
  }

  .liquidaciones-sueldos-pagos-data .registro-ordenes.personal table td {
    vertical-align: middle;
    /* border: none; */
  }
  .liquidaciones-sueldos-pagos-data .registro-ordenes.personal table td[aria-colindex="1"] {
    width: 80%;
  }
  .liquidaciones-sueldos-pagos-data .registro-ordenes.personal table td[aria-colindex="2"] {
    width: 20%;
  }
</style>